import * as React from "react";

import Grid from "@mui/material/Grid";
import variables from "Styles/variables.scss";
import { useTheme } from "@mui/material/styles";
// import { ColorModeContext } from "Helpers/contexts";
// import Brightness4Icon from "@mui/icons-material/Brightness4";

import { FormHeadingTypography, PUCBox, PUCExitApp, PUCFormButton, PUCLocationButton, 
  // PUCUISwitch 
} from "Helpers/overrides";
import unCollapseLogo from "Static/img/logouncollapse.svg";

// import Brightness7Icon from "@mui/icons-material/Brightness7";
// import IconButton from "@mui/material/IconButton";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, 
  // FormControlLabel 
} from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import { Paths } from "Router/Paths";
// import { FormControlLabel, Switch } from "@mui/material";

const PUC_Header = () => {
  const navigate = useNavigate()
  // const value = React.useContext(ColorModeContext);
  // const location = useLocation();
  const theme = useTheme();
  const gridswitch = { display: "flex", alignItems: "center", flexDirection: "row-reverse" };
  const [typeOfForm, setTypeOfForm] = React.useState("")
  const [confirmationPopUp, setconfirmationPopUp] = React.useState(false);

  const formtype = () => {
    // const lastSlashIndex = location.pathname.lastIndexOf('/');
    // const extractedTextWithHyphens = location.pathname.substring(lastSlashIndex + 1);
    // Replace hyphens with spaces
    // const extractedText = extractedTextWithHyphens.split('-').join(' ');
    // Remove numbers
    // const finalTextWithoutNumbers = extractedText.replace(/\d+/g, '');
    // Capitalize the first letter
    // const finalText = finalTextWithoutNumbers.charAt(0).toUpperCase() + finalTextWithoutNumbers.slice(1);
    setTypeOfForm("")
  }
  React.useEffect(() => {
    formtype()
  }, [])

  const handleConfirm = () => {
    setconfirmationPopUp(false)
    navigate(Paths.userDashboard)
  }


  const confirmPopupTemplate = () => {
    return (
      <>
        <Dialog open={confirmationPopUp} onClose={() => setconfirmationPopUp(false)}>
          <DialogTitle>Exit Form</DialogTitle>
          <DialogContent>
            <DialogContentText variant="h3" style={style.exitheading}>
              {`Are you sure you want to exit the form?`}
            </DialogContentText>
            <DialogContentText variant="body1" style={{ marginTop: "12px" }}>
              {`If there are any unsaved changes that will be lost if you leave now.`}
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={() => setconfirmationPopUp(false)}
              color="inherit"
              variant="text"
              size="large">
              Cancel
            </Button>
            <PUCLocationButton
              color="primary"
              variant="contained"
              size="large"
              type="button"
              onClick={handleConfirm}
            >
              Confirm
            </PUCLocationButton>
          </DialogActions>
        </Dialog>
      </>
    );
  };
  return (
    <>
      <PUCBox
        px={{ sm: 5, xs: 3 }}
        py={1}
        borderBottom={"1px solid "}
        borderBottomColor={
          theme.palette.mode === "dark" ? variables.darkBorderColor : variables.offWhite
        }>
        <Grid container >
          <Grid className="gridheader" xs={1} sm={1} item>
            <NavLink to={Paths.userDashboard}>
              <img src={unCollapseLogo} />
            </NavLink>
          </Grid>
          <Grid item xs={7} sm={7} sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }} >
            <FormHeadingTypography variant="h3" >
              {typeOfForm}</FormHeadingTypography>
          </Grid>


          <Grid sx={gridswitch} xs={4} sm={4} item>
            {/* {theme.palette.mode} mode */}
            {/* <FormControlLabel
              sx={{ ml: 1 }}
              control={
                <PUCUISwitch
                  sx={{ m: 1 }}
                  checked={theme.palette.mode === "dark" ? true : false}
                  onClick={value.toggleColorMode}
                />
              }
            /> */}
            {/* <NavLink to={Paths.userDashboard}>  </NavLink> */}
            {" "}
            <PUCFormButton variant="text" size="medium" disableElevation
              onClick={() => setconfirmationPopUp(true)}
            >
              Exit Form <PUCExitApp />
            </PUCFormButton>


            {/* <IconButton sx={{ ml: 1 }} onClick={value.toggleColorMode} color="inherit">
              {theme.palette.mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton> */}
            {/* <FormControlLabel
              control={<Switch checked={theme.palette.mode === 'dark'} onChange={value.toggleColorMode} />}
              label=""
            /> */}
          </Grid>
        </Grid>
      </PUCBox >
      {confirmPopupTemplate()}
    </>
  );
};

const style = {
  exitheading: {
    color: "#000000",
    marginBottom: "10px"
  }
}

export default PUC_Header;
